import { useState } from "react";
import { api } from "../api";
import Swal from "sweetalert2";
import { buildErrorHtml, isValidDate } from "../utils/validation";


export default function AbsenceModal({ student, onClose }) {

  const [date, setDate] = useState("");
  const [reason, setReason] = useState("");

  const user = JSON.parse(localStorage.getItem("user"));

async function handleSubmit() {
  try {
    const errors = [];

    if (!isValidDate(date)) {
      errors.push("Informe uma data válida.");
    }

    if (errors.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Campos inválidos",
        html: buildErrorHtml(errors),
      });
      return;
    }

    await api.post("/absences", {
      studentId: student.id,
      instructorId: user.id,
      date,
      reason
    });

    await Swal.fire({
      icon: "success",
      title: "Falta registrada!",
      text: "A falta foi cadastrada com sucesso.",
      confirmButtonColor: "#0d6efd"
    });

    onClose();

  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Erro",
      text: err.response?.data?.error || "Erro ao registrar falta."
    });
  }
}


  return (
    <div className="custom-modal-overlay">

      <div className="custom-modal">

        <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
          <h4 className="mb-0">
            Lançamento de Falta
          </h4>
          <button
            className="btn-close"
            onClick={onClose}
          />
        </div>

        <div className="mb-4">
          <h6 className="text-muted">
            Aluno
          </h6>
          <h5>{student.name}</h5>
        </div>

        <div className="row">

          <div className="col-md-6 mb-4">
            <label className="form-label">Data da Falta</label>
            <input
              type="date"
              className="form-control"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </div>

          <div className="col-md-6 mb-4">
            <label className="form-label">Motivo</label>
            <input
              className="form-control"
              placeholder="Opcional"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>

        </div>

        <div className="d-flex justify-content-end mt-4 border-top pt-3">
          <button
            className="btn btn-outline-secondary me-2"
            onClick={onClose}
          >
            Cancelar
          </button>

          <button
            className="btn btn-primary"
            onClick={handleSubmit}
          >
            Salvar
          </button>
        </div>

      </div>
    </div>
  );
}
